<template>
    <Header :title="$t('Purchase History')"></Header>

    <!-- App Capsule @click="$router.push('/transactiononedetails/' + il.id + '/' + il.item)"-->
    <div id="appCapsule">
        <ul class="listview image-listview detail-list text wrapper" v-infinite-scroll="loadMore"
            v-infinite-scroll-distance="10">
            <li v-for="il in il_logs" v-bind:key="il.id">
                <a href="javascript:;" class="item">
                    <div class="in">
                        <p>
                            <span class="order">{{ il.orderno }}</span>
                        </p>
                        <p>
                            <span class="bg-success">{{ il.item_name }}</span>
                        </p>
                        <div>
                            <h2 class="mt-1">{{ $t("$") }} {{ il.amount }}</h2>
                            <span class="status">{{$t('Quantity')}}:{{ il.buy_times }}</span>
                        </div>
                        <span class="datetime">{{ il.ctime }}</span>
                    </div>
                </a>
            </li>
            <li>
                <div class="spinner-border text-info mt-2" role="status" v-if="loading_show"></div>
                <div class="mt-2" v-if="no_more">
                    <p>{{ $t("no more data") }}</p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
// @ is an alias to /src
import Header from "../components/Header.vue";
import { getinvestmentlog } from "../common/api";
import i18n from "../lang/index";

export default {
    name: "TransactionDetails",
    components: {
        Header,
    },
    data() {
        return {
            il_logs: [],
            max_page: 0,
            loading: false,
            loading_show: false,
            page: 1,
            limit: 10,
            no_more: false
        };
    },
    mounted() {
        this.getinvestmentlog();
        gotop();
    },
    methods: {
        set_max_page(count) {
            if(this.max_page !== 0) {
                return;
            }
            if (count % this.limit == 0) {
                this.max_page = parseInt(count / this.limit);
            } else {
                this.max_page = parseInt(count / this.limit) + 1;
            }
        },
        loadMore() {
            if(this.loading || this.no_more) {
                return;
            } else {
                this.loading = true;
                this.loading_show = true;
                this.getinvestmentlog();
            }
        },
        getinvestmentlog() {
            // loading(i18n.global.t("Loading..."));
            getinvestmentlog({
                page: this.page,
                limit: this.limit,
            }).then((res) => {
                if (res.code === 200) {
                    this.set_max_page(res.data.count);
                    if (res.data.result.length < this.limit || this.page >= this.max_page) {
                        this.no_more = true;
                        this.loading_show = false;
                        this.loading = true;
                    } else {
                        this.page = this.page + 1;
                        this.loading = false;
                        this.loading_show = false;
                        // loading_close();
                    }
                    this.il_logs.push(...res.data.result);
                }
            });
        }
    },
};
</script>

<style scoped>
.detail-list>li a.item:after {
    background-image: none;
}

.detail-list>li .item .in {
    display: block;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    text-align: left;
}

.detail-list>li .item .in .order {
    color: #086;
}

.detail-list>li .item .in .status {
    position: absolute;
    color: blue;
    right: 54px;
    bottom: 47px;
    text-transform: capitalize;
}

.detail-list>li .item .in .datetime {
    position: absolute;
    right: 20px;
    bottom: 10px;
}

.addamount {
    color: green;
}

.eddamount {
    color: red;
}

.wrapper {
    height: calc(100vh - 55px);
    overflow: scroll;
}

.spinner-border {
    width: 1rem;
    height: 1rem;
}
</style>